<panel width="450">
	<h1><editable-field [value]="taskflow.title" (save)="updateTitle($event)" /></h1>
	<section>
		<taskflow-timeline (createNewTaskAction)="createNewTaskActionFromTimeline($event)"
						   [tentativeTaskAction]="newTimelineTaskAction"
						   [taskflow]="taskflow"
						   [(activeTaskAction)]="selectedTaskAction" />
		@if (sites && sites.length > 0) {
			<section>
				@for (site of sites; track site) {
					<div (click)="openSite(site)">
						<icon type="desktop" />
						<div>{{ siteService.getSitePrimaryPointer(site) }}</div>
						<div>{{ site.created | customDate }}</div>
					</div>
				}
			</section>
		}
		@if (questionnaires.length > 0 && selectedTaskAction) {
			@for (questionnaireInfo of questionnaires; track questionnaireInfo) {
				<questionnaire [questionnaireId]="questionnaireInfo.questionnaire.id"
							   [orderLines]="orderLines"
							   [editable]="questionnaireInfo.editable"
							   [showCategoryDetails]="questionnaireInfo.showCategoryDetails"
							   [taskflowId]="selectedTaskAction.taskflowId"
							   (completed)="updateValidation($event, questionnaireInfo.questionnaire.id!)"></questionnaire>
				}
		}
	</section>
	@for (taskAction of taskflow.taskActions; track taskAction) {
		<view-task-action [taskAction]="taskAction"
							[hidden]="loading || !selectedTaskAction || taskAction.id !== selectedTaskAction.id"
							[blockCompletion]="this.questionnaires.length > 0 && !allQuestionnairesAreValid"
							(createNewTaskAction)="createNewTaskAction($event)" />
	}
</panel>

<panel width="700">
	<h1>{{ 'communication-log.title' | translate }}</h1>
	<task-action-log [company]="company" [taskAction]="selectedTaskAction" [taskflowId]="selectedTaskAction ? undefined : taskflow.id" />
</panel>
@if (newTimelineTaskAction) {
	<new-task-action [taskAction]="newTimelineTaskAction" (taskActionSaved)="newTimelineTaskAction = undefined;" [enableSaveButton]="true" />
}
@if (newTaskAction) {
	<new-task-action [taskAction]="newTaskAction" (taskActionSaved)="closeTaskAction()" [enableSaveButton]="true" />
}
